import type { AdminWorkspace } from '@app/shared';
import { Banner, Icons, Text } from '../ui';

/**
 * Support-mode banner (guardrail b, #326). A persistent, unmistakable WARNING banner shown
 * on the agents list + builder whenever a platform OPERATOR is acting on a FOREIGN
 * workspace — so it is always obvious the operator is editing another customer's agents,
 * not their own. Not dismissible (it must stay visible for the whole support session). The
 * target workspace name + owner come from the operator workspace list already loaded for
 * the picker.
 */
export interface SupportModeBannerProps {
  /** The foreign workspace being edited (from the operator workspace list). */
  workspace: AdminWorkspace | null;
}

export function SupportModeBanner({ workspace }: SupportModeBannerProps) {
  const name = workspace?.name ?? 'another workspace';
  const owner = workspace?.owner.name || workspace?.owner.email;
  return (
    <Banner
      tone="warning"
      icon={Icons.ShieldAlert}
      role="alert"
      data-testid="support-mode-banner"
    >
      <Text as="span" weight="semibold">
        Support mode
      </Text>{' '}
      — editing <Text as="span" weight="semibold">{name}</Text> as a platform operator
      {owner ? ` (owner: ${owner})` : ''}. Changes you publish take effect for this customer
      immediately.
    </Banner>
  );
}
